import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'

const app = createApp(App)
router.beforeEach((to, from, next) => {
    // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  //console.log('路由元信息：', to.meta); // 查看 meta 信息是否正确

  // 先删除所有旧的 meta[name] 和 meta[property] 标签，防止重复添加
  document.querySelectorAll('meta[name], meta[property]').forEach(tag => {
   // console.log('删除 meta:', tag); // 调试：查看是否删除了旧的 meta
    tag.remove();
  });

  // 检查 metaTags 是否存在
  if (to.meta.metaTags && Array.isArray(to.meta.metaTags)) {
    to.meta.metaTags.forEach(tagDef => {
      const metaTag = document.createElement('meta');
      Object.keys(tagDef).forEach(key => {
        metaTag.setAttribute(key, tagDef[key]);
      });
      //console.log('创建 meta:', metaTag); // 调试：查看创建的 meta 标签
      document.head.appendChild(metaTag);
    });
  }

  next();
});
app.use(ElementPlus)
app.use(router)
app.mount('#app')
